import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import { once } from 'lodash';
import getLocale from 'src/js/modules/i18n/selectors/locale';
import getBaseLanguageCodes from 'src/js/modules/config/selectors/base-language-codes';
import getSiteIdRecreate from 'src/js/modules/sites/selectors/get-site-id-recreate';
import getSiteIdToSwitchTemplate from 'src/js/modules/sites/selectors/site-id-to-switch-template';
import analytics from 'src/js/modules/analytics';
import i18n from 'src/js/modules/i18n';
import getCurrentStep from '../../modules/site-setup/helpers/get-current-step';
import { APP_NAME } from '../../constants/common';
import TagManagerContainer from '../../containers/tag-manager-container';
import DialogsContainer from '../../modules/dialogs/containers/dialogs-container';

const callSiteSetupStartedOnce = once((siteId, stepName) => {
  analytics.segment.track(analytics.segment.eventTypes.SITESETUP_STARTED, {
    appName: APP_NAME,
    stepId: stepName,
    siteId,
  });
});

const CorePage = ({
  supportedLocales = null,
  siteIdRecreate = null,
  siteIdToSwitchTemplate = null,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (siteIdToSwitchTemplate) return;

    const { number, stepName } = getCurrentStep();
    if (number) {
      const siteId = siteIdRecreate || null;
      callSiteSetupStartedOnce(siteId, stepName);
    }
  }, [location.pathname, siteIdToSwitchTemplate, siteIdRecreate]);

  useEffect(() => {
    const url = `${location.pathname}${location.search || ''}`;
    const URLWithoutLocale = i18n.helpers.getURLWithoutLocale(url, supportedLocales);

    if (url === URLWithoutLocale) return;

    navigate(URLWithoutLocale, { replace: true });
  }, [location.pathname, location.search, navigate, supportedLocales]);

  return (
    <>
      <TagManagerContainer />
      <DialogsContainer />
      <Outlet />
    </>
  );
};

CorePage.propTypes = {
  supportedLocales: PropTypes.array,
  siteIdRecreate: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  siteIdToSwitchTemplate: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

const mapStateToProps = (state) => {
  const locale = getLocale(state);
  const supportedLocales = (Boolean(locale) && getBaseLanguageCodes(state)) || [];
  const siteIdRecreate = getSiteIdRecreate(state);
  const siteIdToSwitchTemplate = getSiteIdToSwitchTemplate(state);

  return {
    supportedLocales,
    siteIdRecreate,
    siteIdToSwitchTemplate,
  };
};

export default connect(mapStateToProps, null)(CorePage);
